import { Slider } from "@mui/material";
import styled from "styled-components";

interface Props {
  background: string;
}

export const StyledSlider = styled(Slider)((props: Props) => ({
  height: 18,
  color: "#ECECEC !important",
  "& .MuiSlider-track": {
    height: 10,
    background:
      props.background ||
      "linear-gradient(90deg, #2698F1 0%, #FCCF2F 50.51%, #FC2F2F 97.97%) !important",
    border: "none",
  },
  "& .MuiSlider-root": {
    background: "#ECECEC !important",
    border: "none",
  },
}));
